export const actualConfig = {
  title: "Actual Consumption Data",
  storageKey: "actualDates",
  excelConfig: {
    getHeaders: (data, reportType, capitalizeWords) => {
      if (reportType === "daily") {
        return [
          "Branch Name", "Branch Code", "Store Name", "Store Code", "City", "State", "Country",
          "Item Name", "Item Code", "Unit", "Unit Cost", "Opening Stock", "Transfer In", "Closing Stock",
          "Actual Quantity", "Opening Stock Date", "Closing Stock Date"
        ];
      }
      console.log(Object.keys(data[0]).map(capitalizeWords));
      return Object.keys(data[0]).map(capitalizeWords);
    },

    mapRow: (item, reportType, formatValue) => {
      if (reportType === "daily") {
        return [
          item.branch_name,
          item.branch_code,
          item.store_name,
          item.store_code,
          item.city,
          item.state,
          item.country,
          item.item_name,
          item.item_code,
          item.unit,
          formatValue(item.unit_cost),
          formatValue(item.opening_stock),
          formatValue(item.transfer_in),
          formatValue(item.closing_stock),
          formatValue(item.actual_quantity),
          item.opening_stock_date,
          item.closing_stock_date
        ];
      }

      return Object.values(item).map(val =>
        typeof val === "string" && val.startsWith("'")
          ? parseFloat(val.slice(1))
          : formatValue(val)
      );
    }
  },
  apiPayloadBuilder: ({ start_date, end_date, outlets }) => ({
    start_date,
    end_date,
    consumptionType: "Actual",
    outlets
  }),
};
